import { ApplicationCatalog, SelectedApp } from "@/components/applications/ApplicationCatalog";

interface SelectAppStepProps {
  onSelectApp: (app: SelectedApp) => void;
  selectedAppId?: string;
  initialSearchTerm?: string;
}

export const SelectAppStep = ({ onSelectApp, selectedAppId, initialSearchTerm }: SelectAppStepProps) => {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-xl font-semibold">Select an Application</h2>
        <p className="text-muted-foreground mt-1">
          Search the App Store or import from Apple Business Manager
        </p>
      </div>

      <ApplicationCatalog
        onSelectApp={onSelectApp}
        selectedAppId={selectedAppId}
        initialSearchTerm={initialSearchTerm}
      />
    </div>
  );
};
